import i18n from '@/i18n'

export const tvColumns = [
  {
    key: 'name',
    label: i18n.tc('overviewAddons.table.name'),
    width: '30%'
  },
  {
    key: 'channelsAmount',
    label: i18n.tc('overviewAddons.table.channelCount'),
    formatter: value => {
      return value || '-'
    },
    width: '20%'
  },
  {
    key: 'activationDate',
    label: i18n.tc('overviewAddons.table.activationDate'),
    width: '30%'
  },
  {
    key: 'recurring',
    label: i18n.tc('overviewAddons.table.status'),
    colClass: 'flex-grow-1',
    width: '20%',
    slot: 'status'
  },
  {
    key: 'channelList',
    label: ' ',
    slot: 'channelList',
    colClass: 'text-right channel-button-cell',
    width: '100px'
  }
]

export const mobileColumns = [
  {
    key: 'name',
    label: i18n.tc('overviewAddons.table.name'),
    width: '50%'
  },
  {
    key: 'activationDate',
    label: i18n.tc('overviewAddons.table.activationDate'),
    colClass: 'flex-grow-1',
    width: '50%'
  },
  {
    key: 'expirationDate',
    label: i18n.tc('overviewAddons.table.expirationDate'),
    width: '160px',
    slot: 'status'
  }
]
